import { render } from "./Footer-Startup.vue?vue&type=template&id=a657aadc"
import script from "./Footer-Startup.vue?vue&type=script&lang=js"
export * from "./Footer-Startup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__